/**
 * 返回最顶级的根元素
 * 参考文档：https://www.runoob.com/jsref/prop-node-ownerdocument.html
 * @param node 
 */
export const ownerDocument = (node: Element | null): Document => {
  return (node && node.ownerDocument) || document;
}